import $ from "jquery";

/* Accordéons (FAQ et corps de texte) */
$('.accordion__title').click(function() {
    var $this = $(this);
    var $parent = $this.parent('.accordion');
    var $openedBoxes = $('.accordion.active');

    if($parent.length) {
      $('.accordion__content').removeClass('active');

      if($openedBoxes.length) {
        $openedBoxes.each(function(index, box) {
          if(box === $parent[0]) {
            $openedBoxes.splice(index, 1);
          }
        });
        if($openedBoxes.length) {
          $openedBoxes.removeClass('active');
        }
      }
      $parent.toggleClass('active');
    }
});
